import { render, staticRenderFns } from "./CambiarImagenPerfil.vue?vue&type=template&id=828058a4&"
import script from "./CambiarImagenPerfil.vue?vue&type=script&lang=js&"
export * from "./CambiarImagenPerfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports